/**
 * Skeuomorphic Theme - Realistic hardware-style controls
 * Uses custom CSS knobs + basic components for buttons/selects
 */

import { SkeuoKnob } from './SkeuoKnob.js';
// Reuse basic components for elements that work better simple
import { BasicSlider } from '../basic/BasicSlider.js';
import { BasicStepButton } from '../basic/BasicStepButton.js';
import { BasicSelect } from '../basic/BasicSelect.js';
import { BasicLED } from '../basic/BasicLED.js';

export function createKnob(container, options) {
    return new SkeuoKnob(container, options);
}

export function createSlider(container, options) {
    return new BasicSlider(container, options);
}

export function createStepButton(container, options) {
    return new BasicStepButton(container, options);
}

export function createSelect(container, options) {
    return new BasicSelect(container, options);
}

export function createLED(container, options) {
    return new BasicLED(container, options);
}

export { SkeuoKnob };
